export default "__VITE_ASSET__M$CmXZqI__"